export default __webpack_public_path__ + "static/media/students.6ff8eec5.jpeg";